/**
 * @description 通用活动下架提示弹窗
 */

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useRouter } from "@/i18n/navigation";
import Image from "next/image";
import { useTranslations } from "next-intl";

export interface ActivityOfflineNoticeModalProps {
  /** 弹窗标题 */
  title?: string;
  /** 弹窗内容 */
  description?: string;
  btn?: {
    text?: string;
    variant?: 'primary' | 'default' | 'danger' | 'warning' | 'success' | 'cancel';
    onClick?: () => void;
  };
}

const ActivityOfflineNoticeModal = NiceModal.create<ActivityOfflineNoticeModalProps>(({ title, description, btn }) => {
  const modal = useModal();
  const router = useRouter();
  const t_common = useTranslations('common');
  const t_promotions = useTranslations('promotions');

  const handleBtnClick = () => {
    if (btn?.onClick) {
      btn.onClick();
    } else {
      // 回到首页
      router.push('/');
      modal.hide();
    }
  };
  return (
    <Dialog open={modal.visible}>
      <DialogContent
        className="mx-auto w-[85vw] bg-surface border-none rounded-t-[10px] text-white flex flex-col items-center"
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{title || t_common('tips')}</DialogTitle>
        </DialogHeader>
        <Image src="/assets/images/ic_offline.png" alt="activity-offline-notice" width={60} height={60} className="mx-auto mb-4 mt-12" />
        <DialogDescription className="text-center leading-4 font-medium text-tertiary" dangerouslySetInnerHTML={{ __html: description || t_promotions('activityUnavailable') }}></DialogDescription>
        <DialogFooter className="mt-6 w-full">
          <Button className="w-full" onClick={handleBtnClick} variant={btn?.variant || 'primary'}>{btn?.text || 'Home'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

export default ActivityOfflineNoticeModal;

